
import { defineComponent, computed, ref } from "vue";
import { toolbarWidthFluid } from "@/core/helpers/config";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";
import { useRoute } from "vue-router";

export default defineComponent({
  name: "FormToolbar",
  props: {
    breadcrumbs: Array,
    title: String,
  },

  setup(props, context) {
    const store = useStore();
    const route = useRoute();
    const localSearchTerm = ref("");
    const localSorting = ref("");

    const searchKeyUp = () => {
      if (localSearchTerm.value.length >= 3) {
        store.dispatch(Actions.SET_SEARCH_TERM, localSearchTerm.value);
        store.dispatch(Actions.GET_DYNAMIC_LIST);
      } else {
        if (getSearchTerm.value != "") {
          store.dispatch(Actions.SET_SEARCH_TERM, "");
          store.dispatch(Actions.GET_DYNAMIC_LIST);
        }
      }
    };

    const getMapping = computed(() => {
      return store.getters.getMapping;
    });
    const getFiltersMapping = computed(() => {
      return store.getters.getFiltersMapping({ key: useRoute().meta.key });
    });
    const getAddLink = computed(() => {
      return store.getters.getAddLink;
    });
    const getSearchTerm = computed(() => {
      return store.getters.getSearchTerm;
    });
    const createModal = () => {
      store.dispatch(Actions.SETUP_FORM_COMPONENT_OR_MODAL, {});
    };
    const submitForm = () => {
      
      context.emit("submitForm");
    };
    return {
      toolbarWidthFluid,
      localSearchTerm,
      localSorting,
      getMapping,
      getFiltersMapping,
      getAddLink,
      searchKeyUp,
      createModal,
      submitForm,
    };
  },
});
